import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { System } from '@app/core/resources/system';

@Component({
    selector: 'app-resume-system',
    templateUrl: './resume-system.component.html',
    styleUrls: ['./resume-system.component.scss']
})
export class ResumeSystemComponent implements OnChanges {
    @Input() public system: System = new System();
    @Input() public title: string = 'Comprar o vender';
    @Input() public customTitle?: string;
    @Input() public defaultSystems: Array<string> = [];
    @Input() public systemsKey: string = 'userSystem';
    @Input() public countryName: string = '';

    public displayTitle: string = '';

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['customTitle'] || changes['system']) {
            this.updateDisplayTitle();
        }
    }

    private updateDisplayTitle(): void {
        this.displayTitle = this.customTitle ? this.customTitle : this.system.attributes?.name || this.title;
    }
}
